<template>
  <div id="about">
      <mycarousel></mycarousel>
      <div class="about1">
        <p class="title">走进朝睿，关于我们</p>
        <ul>
            <li>
                <p class="aboutTitle">公司简介</p>
                <p class="aboutSubtitle">广州市朝睿信息科技有限公司是一家位于广州的科技公司。我们致力于为客户提供创新的数字解决方案。公司成立于2005年，迄今为止已成为行业内的领先者。<br/><br/>朝睿信息科技有限公司拥有一支专业的团队，他们具备丰富的技术经验和创造力。我们的团队成员擅长开发高质量的软件、网站和移动应用程序，以满足客户的各种需求。我们注重与客户的沟通，并且根据客户的要求量身定制解决方案。<br/><br/>我们的产品和服务涵盖了多个领域，包括商业软件开发、数据分析、云计算、人工智能等。我们秉承着以客户为中心的理念，不断提升我们的技术能力，为客户提供最优质的解决方案。</p>
            </li>
            <li>
                <img src="@/assets/about/about1.png" alt="">
            </li>
        </ul>
      </div>
      <div class="about2">
        <ul>
            <li>
                <p class="aboutTitle">遍布全国的销售网络<br/>提供本地化的服务</p>
                <p class="aboutSubtitle">无论你身在何处，均能获得朝睿本地化的服务体验</p>
            </li>
            <li class="right">
                <div>
                    <p class="num1">1600<span>+</span></p>
                    <p class="num2">合作客户</p>
                </div>
                <div>
                    <p class="num1">10<span>+</span></p>
                    <p class="num2">分子公司</p>
                </div>
                <div>
                    <p class="num1">100<span>+</span></p>
                    <p class="num2">APP上线项目</p>
                </div>
            </li>
        </ul>
      </div>
      <div class="about3">
        <ul>
            <li>
                <p class="aboutTitle">强大的研发实力<br/>安全稳定可靠的系统支持</p>
                <p class="aboutSubtitle">来自朝睿专业的研发团队，打造安全稳定可靠的系统</p>
            </li>
            <li class="right">
                <div>
                    <p class="num1">99.9<span>%</span></p>
                    <p class="num2">客户满意度</p>
                </div>
                <div>
                    <p class="num1">6000<span>+</span></p>
                    <p class="num2">每秒处理数据</p>
                </div>
                <div>
                    <p class="num1"><span>&lt;</span>200<span>ms</span></p>
                    <p class="num2">服务平均相应</p>
                </div>
            </li>
        </ul>
      </div>
      <div class="about4">
            <ul>
                <li class="left">
                    <p class="p1">立即致电联系客服</p>
                    <p class="p2">拨打咨询电话，立即联系开店顾问</p>
                    <img src="@/assets/about/about2.png" alt="">
                    <p class="p3">199-2748-8313</p>
                    <p class="p4">工作时间 9：00 - 18：00</p>
                </li>
                <li class="right">
                    <p class="p1">请留下您的联系方式</p>
                    <p class="p2">客服会在1小时内给您来电讲解哦</p>
                    <input type="text" placeholder="请输入您的联系方式" v-model="form.phone">
                    <!-- <input type="text" placeholder="请输入您地址" v-model="form.address"> -->
                    <textarea name="" id="" cols="30" rows="10" placeholder="请输入您的意向产品和咨询问题" v-model="form.text"></textarea>
                    <button @click="submit()">留言咨询顾问</button>
                </li>
            </ul>
      </div>
      <div class="about5">
        <p class="title">我们的联系方式，快速找到我们</p>
        <!-- <div class="map"> -->
            <baidu-map :center="center" :zoom="zoom"  @ready="handler" class="map">
                <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
                <bm-marker :position="{lng: center.lng, lat: center.lat}"></bm-marker>
            </baidu-map>
        <!-- </div> -->
      </div>
  </div>
</template>

<script>
import mycarousel from  '@/components/carousel/carousel.vue'

export default {
  components: {
    mycarousel,
  },
  data(){
    return {
        form:{
            phone:"",
            // address:"",
            text:""
        },
        center: {lng: 113.395636, lat: 23.132331},
        zoom: 20
    }
  },
  methods: {
    handler ({BMap, map}) {
      console.log(BMap, map)
      this.center.lng = 113.395636
      this.center.lat = 23.132331
      this.zoom = 20
    },
    submit(){
        const phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/;
        if(!phoneReg.test(this.form.phone)){
            this.$message({
                message: '联系方式必填',
                type: 'error'
            });
            return false
        }
        if(this.form.text==''){
            this.$message({
                message: '留言必填',
                type: 'error'
            });
            return false
        }
        this.$message({
          message: '提交成功',
          type: 'success'
        });
    }
  }
}
</script>

<style lang="scss">
  :root {
    --web-max-width: 1920px;
    --web-min-width: 1300px;
  }
  #about{
    .about1{
        min-width:var(--web-min-width);
        // max-width:var(--web-max-width);
        margin: 60px auto 0;
        .title{
            font-size: 30px;
            font-weight: 400;
            color: #333333;
            text-align: center;
        }
        ul{
            width: 1200px;
            margin:60px auto 74px;
            display: flex;
            align-items: center;
            img{
                width: 470px;
                margin-left: 40px;
            }
            .aboutTitle{
                font-size: 38px;
                font-weight: 500;
                color: #333333;
            }
            .aboutSubtitle{
                font-size: 18px;
                font-weight: 400;
                color: #666666;
                margin-top: 24px;
                line-height:1.8;
            }
        }
    }
    .about2{
        min-width:var(--web-min-width);
        // max-width:var(--web-max-width);
        margin: 60px auto 0;
        ul{
            display: flex;
            width: 1200px;
            margin:0 auto 52px;
            border-bottom: 1px solid #F0F1F1;
            padding-bottom: 52px;
            .aboutTitle{
                font-size: 28px;
                font-weight: 400;
                color: #333333;
                margin-bottom: 36px;
            }
            .aboutSubtitle{
                font-size: 16px;
                font-weight: 400;
                color: #A2A5AC;
                width: 630px;
            }
            .right{
                display: flex;
                div{
                    width: 115px;
                }
                .num1{
                    font-size: 44px;
                    font-weight: 400;
                    color: #0071EF;
                    margin-bottom: 64px;
                    position: relative;
                    span{
                        font-size: 32px;
                    }
                }
                .num1::after{
                    content:"";
                    display: block;
                    width: 32px;
                    height: 2px;
                    background: #0071EF;
                    position: absolute;
                    top: 60px;
                    left: 0;
                }
                .num2{
                    font-size: 16px;
                    font-weight: 400;
                    color: #666666;
                }
                div:nth-child(-n+2){
                    margin-right: 112px;
                }
            }

        }
    }
    .about3{
        min-width:var(--web-min-width);
        // max-width:var(--web-max-width);
        margin: 60px auto 0;
        ul{
            display: flex;
            width: 1200px;
            margin:0 auto 52px;
            .aboutTitle{
                font-size: 28px;
                font-weight: 400;
                color: #333333;
                margin-bottom: 36px;
            }
            .aboutSubtitle{
                font-size: 16px;
                font-weight: 400;
                color: #A2A5AC;
                width: 630px;
            }
            .right{
                display: flex;
                div{
                    width: 115px;
                }
                .num1{
                    font-size: 44px;
                    font-weight: 400;
                    color: #0071EF;
                    margin-bottom: 64px;
                    position: relative;
                    span{
                        font-size: 32px;
                    }
                }
                .num1::after{
                    content:"";
                    display: block;
                    width: 32px;
                    height: 2px;
                    background: #0071EF;
                    position: absolute;
                    top: 60px;
                    left: 0;
                }
                .num2{
                    font-size: 16px;
                    font-weight: 400;
                    color: #666666;
                }
                div:nth-child(-n+2){
                    margin-right: 112px;
                }
            }

        }
    }
    .about4{
        min-width:var(--web-min-width);
        // max-width:var(--web-max-width);
        margin: 60px auto 0;
        ul{
            width: 1200px;
            margin:0 auto;
            background: #FFFFFF;
            box-shadow: 0px 2px 18px 1px rgba(217,223,231,0.6);
            border-radius: 8px 8px 8px 8px;
            padding: 70px 150px;
            display: flex;
            .left{
                text-align: center;
                padding-right: 150px;
                margin-right: 150px;
                border-right:1px solid  #EBEDF0;
                .p1{
                    font-size: 30px;
                    font-weight: 400;
                    color: #333333;
                    margin-bottom: 4px;
                }
                .p2{
                    font-size: 20px;
                    font-weight: 400;
                    color: #666666;
                }
                .p3{
                    font-size: 28px;
                    font-weight: 400;
                    color: #333333;
                    margin-bottom: 8px;
                }
                .p4{
                    font-size: 18px;
                    font-weight: 400;
                    color: #666666;
                }
                img{
                    width: 126px;
                    margin: 50px 0 32px;
                }
            }
            .right{
                .p1{
                    font-size: 30px;
                    font-weight: 400;
                    color: #333333;
                    text-align: center;
                    margin-bottom: 2px;
                }
                .p2{
                    font-size: 20px;
                    font-weight: 400;
                    color: #666666;
                    text-align: center;
                    margin-bottom: 32px;
                }
                input,textarea{
                    display: block;
                    padding: 12px;
                    margin-bottom: 16px;
                }
                input{
                    width: 306px;
                    height: 36px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    opacity: 1;
                    border: 1px solid #DCDEE0;
                }
                textarea{
                    width: 306px;
                    height: 80px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    opacity: 1;
                    border: 1px solid #DCDEE0;
                }
                button{
                    width: 306px;
                    height: 50px;
                    background: #0071EF;
                    border-radius: 4px 4px 4px 4px;
                    font-size: 20px;
                    font-weight: 400;
                    color: #FFFFFF;
                }
            }
        }
    }
    .about5{
        .title{
            font-size: 30px;
            font-weight: 400;
            color: #161E30;
            margin-bottom: 60px;
            margin-top: 80px;
            text-align: center;
        }
        .map{
            width: 1200px;
            height: 600px;
            margin:0 auto 80px;
            display: block;

        }
    }
  }
</style>